/**
 * O que faz: Centraliza as dimensões usadas na prévia e nas páginas do PDF.
 * Onde usa: Documento visual, modal de exportação e renderizador PDF.
 * Conexões: DashboardReportDocument e dashboardPdfRenderer.
 * Tabelas: Nenhuma.
 * Data: 27/07/2026.
 */

export type DashboardReportFormat = 'a4' | 'mobile';

export const DASHBOARD_REPORT_FORMATS = {
  a4: {
    pixelWidth: 1754,
    pixelHeight: 2480,
    pdfWidth: 210,
    pdfHeight: 297,
    previewWidth: 526,
  },
  mobile: {
    pixelWidth: 1080,
    pixelHeight: 1920,
    pdfWidth: (1080 * 0.75) / 25.4,
    pdfHeight: (1920 * 0.75) / 25.4,
    previewWidth: 324,
  },
} as const;
